import type { PopupRequest } from "@azure/msal-browser";

/** Must match PublicClientApplication in index.tsx. */
export const MSAL_AUTHORITY =
    (process.env.REACT_APP_MSAL_AUTHORITY || "").trim() ||
    "https://login.microsoftonline.com/5bbe8fd4-7b77-4257-8bae-e91d2053b70d";

export const MSAL_LOGIN_REQUEST: PopupRequest = {
    scopes: ["openid", "profile", "email"],
    authority: MSAL_AUTHORITY,
};
